import { get } from "lodash";

export const shouldShowRequiredPolicies = loan => Boolean(get(loan, "insurance.requiredPolicies"));

export const shouldShowMandatoryPrePayments = loan => Boolean(get(loan, "insurance.mandatoryPrePayments"));

export const shouldShowRestoration = loan => Boolean(get(loan, "insurance.restoration"));
